<template>
  <div>
    <CheckboxTeamInstruction
      name="distribute-quickly"
      :value="distributeQuickly"
      mutation="updateDistributeQuickly"
      :incompatible="slowPaceDown"
    >
      {{ $t('tactics.instructions.transitions.goalkeeper.distributeQuickly') }}
    </CheckboxTeamInstruction>

    <CheckboxTeamInstruction
      name="slow-pace-down"
      :value="slowPaceDown"
      mutation="updateSlowPaceDown"
      :incompatible="distributeQuickly"
    >
      {{ $t('tactics.instructions.transitions.goalkeeper.slowPaceDown') }}
    </CheckboxTeamInstruction>
  </div>
</template>

<script>
import CheckboxTeamInstruction from "@/components/CheckboxTeamInstruction";

export default {
  components: {
    CheckboxTeamInstruction
  },

  computed: {
    goalkeeperTransition () {
      return this.$store.state.instructions.inTransition.goalkeeperInPossession;
    },

    distributeQuickly () {
      return this.goalkeeperTransition === 1;
    },

    slowPaceDown () {
      return this.goalkeeperTransition === -1;
    }
  }
};
</script>

<style scoped>

</style>
